import { useQueries } from '@tanstack/react-query';
import { AttachMoney, Person } from '@mui/icons-material';
import { Grid } from '@mui/material';

import { QueryRenderer } from '@barboxx/admin-components';
import Api from '@barboxx/api';
import { USD } from '@barboxx/utils';

import SmallCount from './components/cards/SmallCount';
import { SmallGridItem } from './components/GridItems';

// Generated by Copilot

export function BusinessDashboard() {
    const [dashboardSummary] = useQueries({
        queries: [
            {
                queryKey: ['businessDashboard'],
                queryFn: () => Api.Dashboard.getBusinessDashboardSummary(),
            },
        ],
    });

    return (
        <QueryRenderer results={dashboardSummary}>
            {data => (
                <Grid container direction="row" spacing={2}>
                    <SmallGridItem>
                        <SmallCount
                            title="Employees"
                            value={data.employeeCount}
                            icon={<Person />}
                        />
                    </SmallGridItem>
                    <SmallGridItem>
                        <SmallCount
                            title="businesses"
                            value={data.businessCount}
                            icon={<Person />}
                        />
                    </SmallGridItem>
                    <SmallGridItem>
                        <SmallCount
                            title="Total Sales"
                            value={USD(data.totalSales).format()}
                            icon={<AttachMoney />}
                        />
                    </SmallGridItem>
                    <SmallGridItem>
                        <SmallCount
                            title="Total Orders"
                            value={data.currentOrders}
                            icon={<AttachMoney />}
                        />
                    </SmallGridItem>
                </Grid>
            )}
        </QueryRenderer>
    );
}
